'use client';

import type { CSSProperties } from 'react';
import { usePublicUi } from '@/lib/publicUi';

export interface SelectionActionHandlesProps {
  showEye: boolean;
  showEnter: boolean;
  fillColor: string;
  onView: () => void;
  onEnter: () => void;
}

const SIZE = 25;
const OFFSET = -12;

/**
 * Twin of Containd DraggableSquare corner discs (roundness NE / resize SE),
 * used as view / enter buttons in the public-share player.
 */
export function SelectionActionHandles({
  showEye,
  showEnter,
  fillColor,
  onView,
  onEnter,
}: SelectionActionHandlesProps) {
  const { extra } = usePublicUi();
  if (!showEye && !showEnter) return null;

  const disc: CSSProperties = {
    position: 'absolute',
    width: SIZE,
    height: SIZE,
    borderRadius: SIZE,
    background: fillColor,
    border: '3px solid #fff',
    boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    cursor: 'pointer',
    zIndex: 5,
    color: '#fff',
  };

  return (
    <>
      {showEye ? (
        <button
          type="button"
          aria-label={extra.shareViewItem}
          style={{ ...disc, right: OFFSET, top: OFFSET }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onView();
          }}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <EyeIcon />
        </button>
      ) : null}
      {showEnter ? (
        <button
          type="button"
          aria-label={extra.shareEnterCanvas}
          style={{ ...disc, right: OFFSET, bottom: OFFSET }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onEnter();
          }}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <EnterIcon />
        </button>
      ) : null}
    </>
  );
}

function EyeIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function EnterIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M9 5v4H4v6h5v4l8-7-8-7Z"
        fill="currentColor"
      />
    </svg>
  );
}
